import { render, staticRenderFns } from "./SearchNoCredits.vue?vue&type=template&id=c56b7e8a&scoped=true&"
import script from "./SearchNoCredits.vue?vue&type=script&lang=ts&"
export * from "./SearchNoCredits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56b7e8a",
  null
  
)

export default component.exports